import 'jquery';

const toggleMenu = () => {
    $('.collapse').fadeToggle();
    $('.collapse__wrapper').toggleClass('active');
}

$(document).on('click', '.navbar-toggler', function() {
    toggleMenu();
    $(this).toggleClass('collapsed active')
    $('.header__toggler-wrapper').toggleClass('active')
});

$(document).keydown(function(event) {
    if (event.keyCode === 27) {
        if ($('.collapse').is(':visible')) {
            toggleMenu();
            $('.navbar-toggler').toggleClass('collapsed active')
            $('.header__toggler-wrapper').toggleClass('active')
        }
    }
});
